import React, { useEffect } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTechnicalRepresentative, fetchTechnicalRepresentativeFilter, technicalRepresentativeClear, technicalRepresentativeFilterClear } from 'app/actions/TechnicalRepresentativeActions';
import { getTechnicalRepresentative, getTechnicalRepresentativeFilter, getIsLoadingTechnicalRepresentative } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';

export default function TechnicalRepresentativeTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const { siteId } = useSelector(state => state.Auth);

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'responsibleName',
            key: 'responsibleName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {

        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idResponsible',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>
                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showEdit = (param) => {
        props.isVisibleForm(true);
        props.setIdResponsible(param.idResponsible);
        props.setNameResponsible(param.responsibleName);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Representante Técnico?',
            content: param.responsibleName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setFiltroNombre(props.FiltroNombre.filter(x => x !== param.responsibleName));
                return deleteResponsible(param);
            },
            onCancel() { },
        });

    }

    async function deleteResponsible(param) {
        await ApiService.deleteResponsible(param.idResponsible).then(res => {
            dispatch(technicalRepresentativeClear());
            dispatch(technicalRepresentativeFilterClear());
            dispatch(fetchTechnicalRepresentativeFilter({ idRol: 1 }))
            dispatch(fetchTechnicalRepresentative({
                responsibleName: props.FiltroNombre.filter(x => x !== param.responsibleName).join(','),
                idRol: 1,
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit
            }));
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let technicalRepresentative = useSelector(getTechnicalRepresentative);
    let technicalRepresentativeFilter = useSelector(getTechnicalRepresentativeFilter);

    let isLoading = useSelector(getIsLoadingTechnicalRepresentative);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(technicalRepresentative)) fetchTechnicalRepresentativeAction();
        if (isEmpty(technicalRepresentativeFilter)) fetchTechnicalRepresentativeFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchTechnicalRepresentative(
            {
                responsibleName: props.FiltroNombre.join('|'),
                idRol: 1,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && technicalRepresentative.length > 0) {
            pagination.total = technicalRepresentative[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }



    const fetchTechnicalRepresentativeAction = () => dispatch(fetchTechnicalRepresentative({
        responsibleName: props.FiltroNombre !== undefined ? props.FiltroNombre.join(',') : '',
        idRol: 1,
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit
    }));
    const fetchTechnicalRepresentativeFilterAction = () => dispatch(fetchTechnicalRepresentativeFilter({ idRol: 1 }))
    return (props.children({ pagination: pagination, cols: columns, technicalRepresentative, technicalRepresentativeFilter, isLoading, handleTableChange: handleTableChange }));
}

